<template>
  <DataTable
    :headers="inspectionConfig.aggregateEquipmentHeaders"
    :data="data"
    :unit="$store.state.unit"
    :items-per-page="20"
    :loading="loading"
    loading-text="Loading metrics, please wait..."
    primary-key="filterKey"
    @onTableCellClick="handleTableCellClick"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import MetricController from '@/controllers/MetricController';
import { DataTable } from '@/components';
import { extractNestedFields } from '../utils';

export default {
  name: 'AggregateTableContainer',
  components: {
    DataTable,
  },
  props: {
    filter: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: true,
      data: undefined,
    };
  },
  computed: mapGetters({
    inspectionConfig: 'config/inspectionConfig',
  }),
  watch: {
    filter: {
      immediate: true,
      handler(value) {
        this.loadData(value);
      },
    },
  },
  methods: {
    async loadData(filter) {
      this.loading = true;

      const aggregationKey = '$data.meta.AutoCad:LineKey';
      const { data } = await MetricController.getMetricAggregate(
        this.$route.query.id,
        'asset',
        2,
        filter,
        aggregationKey
      );

      const { corrosionLayers, aggregateEquipmentHeaders } = this.inspectionConfig;
      const customFields = { filterKey: 'data.meta["AutoCad:LineKey"]' };
      this.data = extractNestedFields(Object.entries(corrosionLayers), aggregateEquipmentHeaders, data, customFields);
      this.loading = false;
    },
    handleTableCellClick(row) {
      this.$emit('onDetailFieldClick', row);
    },
  },
};
</script>
